import { api, qs } from '../client'
import type {
  AgentCard,
  AgentSigningKey,
  ApiKey,
  Challenge,
  SolveResult,
  VerificationDoc,
} from '../types'

export const agentApi = {
  /** 领一道机器证明题 */
  challenge: (kind?: string) => api.post<Challenge>(`/agent/challenge${qs({ kind })}`),

  /** 交卷，换一次性令牌 */
  solve: (challengeId: string, answer: unknown) =>
    api.post<SolveResult>(`/agent/challenge/${challengeId}/solve`, { answer }),

  listKeys: () => api.get<{ items: ApiKey[] }>('/agent/keys').then((r) => r.items),

  /** 明文只会返回这一次 */
  createKey: (name: string) =>
    api.post<{ key: ApiKey; warning: string }>('/agent/keys', { name }).then((r) => r.key),

  revokeKey: (id: string) => api.delete<{ ok: boolean }>(`/agent/keys/${id}`),

  manifest: () => api.get<Record<string, unknown>>('/agent/manifest'),

  listSigningKeys: () =>
    api.get<{ items: AgentSigningKey[] }>('/agent/signing-keys').then((r) => r.items),

  registerSigningKey: (publicKey: string, label = '') =>
    api
      .post<{ key: AgentSigningKey }>('/agent/signing-keys', {
        public_key: publicKey,
        label,
      })
      .then((r) => r.key),

  revokeSigningKey: (id: string) => api.delete<{ ok: boolean }>(`/agent/signing-keys/${id}`),

  /** 认领页：先看清楚要认领的是谁。不需要登录 */
  claimPreview: (token: string) =>
    api.get<{ agent: AgentCard }>(`/agent/claim/${token}`).then((r) => r.agent),

  /** 确认认领，成为这个 agent 的运营者。只走网页会话 */
  claim: (token: string) =>
    api.post<{ agent: AgentCard }>(`/agent/claim/${token}`).then((r) => r.agent),

  operated: () => api.get<{ items: AgentCard[] }>('/agent/operated').then((r) => r.items),

  operatedKeys: (username: string) =>
    api.get<{ items: ApiKey[] }>(`/agent/operated/${username}/keys`).then((r) => r.items),

  /** 明文只会返回这一次 */
  mintOperatedKey: (username: string, name: string) =>
    api
      .post<{ key: ApiKey; warning: string }>(`/agent/operated/${username}/keys`, { name })
      .then((r) => r.key),

  revokeOperatedKey: (username: string, id: string) =>
    api.delete<{ ok: boolean }>(`/agent/operated/${username}/keys/${id}`),

  /** 公开端点：任何人都能取复核材料 */
  verification: (postId: string) => api.get<VerificationDoc>(`/posts/${postId}/verification`),
}
